/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React, { useMemo, useRef } from "react";

import { bem } from "../../../shared/BEM";
import { IButtonComponentProps, Button } from "./ButtonComponent";

/**
 * Component props
 */
export interface IButtonOpenComponentProps extends IButtonComponentProps {
	accept?: string;
	onOpen: (files: FileList) => void;
}

/**
 * Open file Button
 *
 * @param props Component props
 */
export function ButtonOpen(props: IButtonOpenComponentProps) {

	const formRef = useRef<HTMLFormElement>(null);
	const inputRef = useRef<HTMLInputElement>(null);

	const handleClick = useMemo(() => () => {

		inputRef.current.click();

		if (props.onClick) {
			props.onClick();
		}

	}, [ props.onClick ]);

	const handleInput = useMemo(() => () => {

		console.log("OPEN", inputRef.current.files);

		props.onOpen(inputRef.current.files);

		setTimeout(() => formRef.current.reset(), 100);

	}, [ props.onOpen ]);

	return <>
		<Button {...props} onClick={handleClick} />
		<form ref={formRef} className={bem("button", "open-form").str}>
			<input type="file" name="file" ref={inputRef} accept={props.accept} multiple={true} onInput={handleInput} />
		</form>
	</>

}
